<template>
  <div
    class="rp-button-float"
    v-on:click="buyNow"
    v-bind:class="{
      'rp-cart-pulse': cartPulse
    }"
    v-bind:style="{
      backgroundColor: '#ffffff',
      color: buttonColor.primary,
      borderColor: buttonColor.primary,
      fontFamily: globalFont,
      position: buttonPosition,
      boxShadow: buttonColor.shadow
    }"
    v-if="totalProductQuantity > 0" v-on:mousedown.left="dragMouseDown" @touchstart="touchElement"
  >
    <div class="icon">
      <i class="fa fa-lg fa-shopping-cart"></i>
    </div>

    <div class="price">{{ totalProductPrice | productPriceFormat }}</div>

    <span
      class="badge"
      v-bind:style="{
        backgroundColor: buttonColor.primary,
        color: buttonColor.secondary,
      }"
    >
      {{ totalProductQuantity | productCountFormat }}
    </span>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'ButtonStyle2',
  data () {
    return {
      cartPosition: 'fixed'
    }
  },
  computed: {
    totalProductQuantity () {
      return Cart.totalProductQuantity
    },
    color () {
      return Cart.getColor()
    },
    globalFont () {
      return Cart.getGlobalFont()
    },
    totalProductPrice () {
      return Cart.totalProductPrice
    },
    buttonPosition () {
      return this.cartPosition
    },
    buttonColor () {
      let buttonColor = {}
      buttonColor.primary = this.color.primaryMain
      buttonColor.secondary = this.color.primarySub

      if (this.getColorContrast(this.color.primaryMain, '#ffffff') <= 1.5) {
        if (this.getColorContrast(this.color.secondaryMain, '#ffffff') <= 1.5) {
          buttonColor.primary = '#000000'
          buttonColor.secondary = '#ffffff'
        } else {
          buttonColor.primary = this.color.secondaryMain
          buttonColor.secondary = this.color.secondarySub
        }
      }

      let r = parseInt(buttonColor.primary.slice(1, 3), 16)
      let g = parseInt(buttonColor.primary.slice(3, 5), 16)
      let b = parseInt(buttonColor.primary.slice(5, 7), 16)
      buttonColor.shadow = '0 0px 5px rgba(' + r + ', ' + g + ', ' + b + ', 0.5 )'
      return buttonColor
    },
    cartPulse () {
      return Cart.cartPulse
    }
  },
  methods: {
    buyNow () {
      if (this.$isDrag) {
        this.$isDrag = false
        return
      }
      if (this.totalProductQuantity > 0) {
        this.cartPosition = 'fixed'
        Cart.$emit('openCart', 'CartView')
      }
    },
    dragMouseDown (e) {
      this.$position3 = e.clientX || e.touches[0].clientX
      this.$position4 = e.clientY || e.touches[0].clientY

      document.onmouseup = this.closeDragElement
      // call a function whenever the cursor moves:
      document.onmousemove = this.dragElement
    },
    dragElement (e) {
      // calculate the new cursor position:
      let posX = e.clientX || e.touches[0].clientX
      let posY = e.clientY || e.touches[0].clientY
      this.$position1 = this.$position3 - posX
      this.$position2 = this.$position4 - posY
      this.$position3 = e.clientX || e.touches[0].clientX
      this.$position4 = e.clientY || e.touches[0].clientY
      // set the element's new position:
      this.cartPosition = 'absolute'
      this.$el.style.top = (this.$el.offsetTop - this.$position2) + "px"
      this.$el.style.left = (this.$el.offsetLeft - this.$position1) + "px"
      this.$isDrag = true
      this.cartPosition = 'fixed'
    },
    closeDragElement () {
      // stop moving when mouse button is released:
      document.onmouseup = null
      document.onmousemove = null
    },
    touchElement (e) {
      let bodyBgElement = document.getElementById('body-bg')
      if (typeof bodyBgElement !== 'undefined' && bodyBgElement !== null) {
        if (bodyBgElement.style.setProperty) {
          bodyBgElement.style.setProperty('position', 'fixed');
        } else {
          bodyBgElement.style.setAttribute('position', 'fixed');
        }
      } 
      this.$position3 = e.clientX || e.touches[0].clientX
      this.$position4 = e.clientY || e.touches[0].clientY 
      document.ontouchend = this.endTouchElement  
      document.ontouchmove = this.touchMoveElement
    },
    touchMoveElement (e) {
      // calculate the new cursor position:
      let posX = e.clientX || e.touches[0].clientX
      let posY = e.clientY || e.touches[0].clientY
      this.$position1 = this.$position3 - posX
      this.$position2 = this.$position4 - posY
      this.$position3 = e.clientX || e.touches[0].clientX
      this.$position4 = e.clientY || e.touches[0].clientY
      // set the element's new position:
      this.cartPosition = 'absolute'
      this.$el.style.top = (this.$el.offsetTop - this.$position2) + "px"
      this.$el.style.left = (this.$el.offsetLeft - this.$position1) + "px"
      this.$isDrag = true
      this.cartPosition = 'fixed'
    },
    endTouchElement () {
      document.ontouchmove = null
      document.ontouchend = null
      let bodyBgElement = document.getElementById('body-bg')
      if (typeof bodyBgElement !== 'undefined' && bodyBgElement !== null) {
        if (bodyBgElement.style.removeProperty) {
          bodyBgElement.style.removeProperty('position');
        } else {
          bodyBgElement.style.removeAttribute('position');
        }
      }
    },
    hex2dec (hexString) {
      hexString = (hexString + '').replace(/[^a-f0-9]/gi, '')
      return parseInt(hexString, 16)
    },
    getColorContrast (hexColor1, hexColor2) {
      // hexColor1 RGB
      let R1 = this.hex2dec(hexColor1.substr(1, 2))
      let G1 = this.hex2dec(hexColor1.substr(3, 2))
      let B1 = this.hex2dec(hexColor1.substr(5, 2))

      // hexColor2 RGB
      let R2 = this.hex2dec(hexColor2.substr(1, 2))
      let G2 = this.hex2dec(hexColor2.substr(3, 2))
      let B2 = this.hex2dec(hexColor2.substr(5, 2))

      // Calc contrast ratio
      let L1 = 0.2126 * Math.pow(R1 / 255, 2.2) + 0.7152 * Math.pow(G1 / 255, 2.2) + 0.0722 * Math.pow(B1 / 255, 2.2)

      let L2 = 0.2126 * Math.pow(R2 / 255, 2.2) + 0.7152 * Math.pow(G2 / 255, 2.2) + 0.0722 * Math.pow(B2 / 255, 2.2)

      let contrastRatio = 0
      if (L1 > L2) {
        contrastRatio = parseFloat((L1 + 0.05) / (L2 + 0.05)).toFixed(1)
      } else {
        contrastRatio = parseFloat((L2 + 0.05) / (L1 + 0.05)).toFixed(1)
      }
      return contrastRatio
    }
  },
  filters: {
    currency (value) {
      if (value === '-' || value === 'free') {
        return Cart.t.free
      } else {
        return Cart.getCurrency(value)
      }
    },
    productPriceFormat (value) {
      if (value === '-' || value === 'free') {
        return value
      } else {
        if (value >= 100000) {
          let suffixes = ['', 'K', 'M', 'B', 'T']
          let pows = [ 1, 3, 6, 9, 12 ]
          let valueLength = value.toString().length
          let divider = ( valueLength <= 10 ) ? 4:3
          let suffixNumber = Math.floor( valueLength / divider )
          let shortValue = (value / Math.pow(10, pows[suffixNumber])).toLocaleString(undefined, { maximumFractionDigits: 1, minimumFractionDigits: 1 })
          return shortValue + suffixes[suffixNumber]
        } else {
          return Cart.setNumberFormat(value)
        }
      }
    },
    productCountFormat (value) {
      if (value >= 10) {
        return '9+'
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  span {
    font-family: kanit
  }
  .rp-cart-pulse {
    animation: rpCartPulse .5s 2;
  }
  @-webkit-keyframes rpCartPulse {
    0% {
      -webkit-box-shadow: 0 0 0 0;
    }
    70% {
      -webkit-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
  @keyframes rpCartPulse {
    0% {
      -moz-box-shadow: 0 0 0 0;
      box-shadow: 0 0 0 0;
    }
    70% {
      -moz-box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CartButton/ButtonStyle2.vue